export const DEFAULT_WEEKLY_BRIEF_MIN_WEEKLY_VOLUME = 20;
export const DEFAULT_WEEKLY_BRIEF_MIN_TOPIC_VOLUME = 10;
export const WEEKLY_BRIEF_HISTORY_PAGE_SIZE = 20;
